import OperationsPermitRoutePage from "../Operations/OperationsPermitRoutePage";

const PermitsHomePage = () => {
  return <OperationsPermitRoutePage />;
};

export default PermitsHomePage;
